import { get, post, put, Delete } from "../axios";

// 课程分类-列表
export const courseClassifyList = (params) =>
  get("/web/course/classify/list", params);

// 课程分类-全部分类
export const courseClassifyListAll = (params) =>
  get("/web/course/classify/listAll", params);

// 课程分类-新增
export const courseClassifyAdd = (params) =>
  post("/web/course/classify/add", params);

// 课程分类-编辑
export const courseClassifyUpdate = (params) =>
  put("/web/course/classify/update", params);

// 课程分类-删除
export const courseClassifyDelete = (id) =>
  Delete("/web/course/classify/delete/" + id, "");

// 课程分类-状态编辑
export const courseClassifyStateUpdate = (params) =>
  put("/web/course/classify/state/update", params);

/**
 * 课程分类-批量更新树结构（拖拽排序）
 * @param {Object} params - { treeList: Array<WebCourseClassifyTreeBatchUpdateDTO> }
 * @returns {Promise} API 请求 Promise
 */
export const courseClassifyTreeBatchUpdate = (params) =>
  put("/web/course/classify/tree/batchUpdate", params);
